exports.eventCodeMap = {
  "Xrt3PUXOUy": "earn1000",
  "1W2xLJ3UmA": "earn700",
  "UNefkvdhgq": "earn500",
  "Ons3mImXNH": "earn200",
  "R1sMkwEu21": "Daily 50",
  "d1VIQIzOr6": "Daily Survey",
  "3OCsLJ4DVW": "Daily Task",
  "b5pBgCZYcX": "Daily Partner",
  "sCQHFGWk2B": "PTC Clicked",
  "eqGFrZqrY9": "earn100",
  "B8zzQke989": "Survey Started",
  "GUaICQuGwP": "Offer Started",
  "zxjhU1Ucuu": "earning",
  "kqmT6A30Q4": "PartnerOpen",
  "5I5oZAYZL8": "Registration",
  "719qCHiv66": "Register",
  "dxZXGG1qqL": "Share",
  "Q4YsqBKnzZ": "Purchase"
};
